var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.dense
        ? [
            _c("div", { staticClass: "row q-gutter-x-md" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "q-list",
                    { staticClass: "basic-info-list" },
                    [
                      _vm.logArea
                        ? _c(
                            "q-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "q-item-section",
                                [
                                  _c("q-item-label", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("logArea")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("q-item-label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("area")(
                                          _vm.logArea,
                                          _vm.unitLabel("sqm"),
                                          _vm.userLocale
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.palletInfo && _vm.user && !_vm.isTableTop
                        ? _c(
                            "q-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "q-item-section",
                                [
                                  _c("q-item-label", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("palletInfo")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("q-item-label", [
                                    _vm._v(_vm._s(_vm.palletInfo))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user &&
                      !_vm.simplified &&
                      _vm.logInfo &&
                      _vm.isTableTop
                        ? _c(
                            "q-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "q-item-section",
                                [
                                  _c("q-item-label", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("logInfo")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("q-item-label", [
                                    _vm._v(_vm._s(_vm.logInfo))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.thicknessMm && !_vm.isDefaultThickness
                        ? _c(
                            "q-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "q-item-section",
                                [
                                  _c("q-item-label", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("thickness")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("q-item-label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberWithUnit")(
                                          _vm.thicknessMm,
                                          "mm",
                                          _vm.userLocale
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "q-list",
                    { staticClass: "basic-info-list" },
                    [
                      _vm.maxLength
                        ? _c(
                            "q-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "q-item-section",
                                [
                                  _c("q-item-label", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("maxLength")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("q-item-label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberWithUnit")(
                                          _vm.maxLength,
                                          "cm",
                                          _vm.userLocale
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.grade && _vm.user && !_vm.simplified
                        ? _c(
                            "q-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "q-item-section",
                                [
                                  _c("q-item-label", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("grade")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("q-item-label", [
                                    _vm._v(
                                      _vm._s(_vm._f("encodeGrade")(_vm.grade))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.internalQualityName && _vm.user && !_vm.isTableTop
                        ? _c(
                            "q-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "q-item-section",
                                [
                                  _c("q-item-label", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("internalQuality")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("q-item-label", [
                                    _vm._v(_vm._s(_vm.internalQualityName))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("q-slide-transition", [
              !_vm.collapsed
                ? _c(
                    "div",
                    [
                      _c("q-separator", { attrs: { spaced: "" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row q-gutter-x-md" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c(
                              "q-list",
                              { staticClass: "basic-info-list" },
                              [
                                _vm.customerQualityName && !_vm.simplified
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("quality"))
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(
                                                _vm._s(_vm.customerQualityName)
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.place && _vm.user && !_vm.simplified
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.$t("place")))
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(_vm._s(_vm.place))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.user &&
                                !_vm.simplified &&
                                _vm.logInfo &&
                                !_vm.isTableTop
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("logInfo"))
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(_vm._s(_vm.logInfo))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.user && _vm.palletInfo && _vm.isTableTop
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("palletInfo"))
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(_vm._s(_vm.palletInfo))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.resultAreaNotRemeasured &&
                                (_vm.logSearchParams.lengthFrom ||
                                  _vm.logSearchParams.widthFrom ||
                                  _vm.logSearchParams.widthTo)
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("packageArea"))
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("area")(
                                                    _vm.resultAreaNotRemeasured,
                                                    _vm.unitLabel("sqm"),
                                                    _vm.userLocale
                                                  )
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.resultAreaNotRemeasured &&
                                _vm.logArea &&
                                (_vm.logSearchParams.lengthFrom ||
                                  _vm.logSearchParams.widthFrom ||
                                  _vm.logSearchParams.widthTo)
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("inLogPercentage")
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("numberWithUnit")(
                                                    (_vm.resultAreaNotRemeasured /
                                                      _vm.logArea) *
                                                      100,
                                                    _vm.unitLabel("percentage"),
                                                    _vm.userLocale,
                                                    0,
                                                    0
                                                  )
                                                ) + "\n                  "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c(
                              "q-list",
                              { staticClass: "basic-info-list" },
                              [
                                _vm.structure && !_vm.simplified
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("structure"))
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(_vm._s(_vm.structure))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.palletNo && _vm.user && !_vm.simplified
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("palletNo"))
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(_vm._s(_vm.palletNo))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.characteristic
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("characteristic")
                                                  )
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(_vm._s(_vm.characteristic))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.resultAreaMeasuredBack &&
                                _vm.logSearchParams.lengthMax
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("measuredArea")
                                                  ) +
                                                    " (" +
                                                    _vm._s(_vm.$t("unit.sqm")) +
                                                    ")"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("numberWithUnit")(
                                                    _vm.resultAreaMeasuredBack,
                                                    _vm.unitLabel("sqm"),
                                                    _vm.userLocale
                                                  )
                                                ) + "\n                  "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.resultAreaMeasuredBack &&
                                _vm.resultAreaNotRemeasured &&
                                _vm.logSearchParams.lengthMax
                                  ? _c(
                                      "q-item",
                                      { attrs: { dense: "" } },
                                      [
                                        _c(
                                          "q-item-section",
                                          [
                                            _c("q-item-label", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("measuredArea")
                                                  ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.$t("unit.percentage")
                                                    ) +
                                                    ")"
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("q-item-label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("numberWithUnit")(
                                                    (_vm.resultAreaMeasuredBack /
                                                      _vm.resultAreaNotRemeasured) *
                                                      100,
                                                    _vm.unitLabel("percentage"),
                                                    _vm.userLocale,
                                                    0,
                                                    0
                                                  )
                                                ) + "\n                  "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm._t("default")
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("q-btn", {
              staticClass: "card-collapse-button",
              attrs: {
                flat: "",
                color: "primary",
                icon: _vm.collapsed ? "add" : "remove",
                label: _vm.collapsed ? _vm.$t("more") : _vm.$t("less"),
                padding: "4px 4px 4px 0",
                "no-caps": ""
              },
              on: {
                click: function($event) {
                  _vm.collapsed = !_vm.collapsed
                }
              }
            })
          ]
        : [
            _c("ul", { staticClass: "merged-info-list" }, [
              _vm.logArea
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("logArea")))]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("area")(
                            _vm.logArea,
                            _vm.unitLabel("sqm"),
                            _vm.userLocale
                          )
                        )
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.resultAreaNotRemeasured &&
              (_vm.logSearchParams.lengthFrom ||
                _vm.logSearchParams.widthFrom ||
                _vm.logSearchParams.widthTo)
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("packageArea")))]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("area")(
                            _vm.resultAreaNotRemeasured,
                            _vm.unitLabel("sqm"),
                            _vm.userLocale
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.resultAreaNotRemeasured &&
              _vm.logArea &&
              (_vm.logSearchParams.lengthFrom ||
                _vm.logSearchParams.widthFrom ||
                _vm.logSearchParams.widthTo)
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("inLogPercentage")))]),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("numberWithUnit")(
                            (_vm.resultAreaNotRemeasured / _vm.logArea) * 100,
                            _vm.unitLabel("percentage"),
                            _vm.userLocale,
                            0,
                            2
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.resultAreaMeasuredBack && _vm.logSearchParams.lengthMax
                ? _c("li", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("measuredArea")) +
                          " (" +
                          _vm._s(_vm.$t("unit.sqm")) +
                          ")"
                      )
                    ]),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("numberWithUnit")(
                            _vm.resultAreaMeasuredBack,
                            _vm.unitLabel("sqm"),
                            _vm.userLocale
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.resultAreaMeasuredBack &&
              _vm.resultAreaNotRemeasured &&
              _vm.logSearchParams.lengthMax
                ? _c("li", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("measuredArea")) +
                          " (" +
                          _vm._s(_vm.$t("unit.percentage")) +
                          ")"
                      )
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("numberWithUnit")(
                            (_vm.resultAreaMeasuredBack /
                              _vm.resultAreaNotRemeasured) *
                              100,
                            _vm.unitLabel("percentage"),
                            _vm.userLocale,
                            0,
                            2
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.maxLength
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("maxLength")))]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("numberWithUnit")(
                            _vm.maxLength,
                            "cm",
                            _vm.userLocale
                          )
                        )
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.customerQualityName && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("quality")))]),
                    _vm._v(" " + _vm._s(_vm.customerQualityName))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.structure && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("structure")))]),
                    _vm._v(" " + _vm._s(_vm.structure))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.grade && _vm.user && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("grade")))]),
                    _vm._v(" " + _vm._s(_vm._f("encodeGrade")(_vm.grade)))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.palletNo && _vm.user && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("palletNo")))]),
                    _vm._v(" " + _vm._s(_vm.palletNo))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.place && _vm.user && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("place")))]),
                    _vm._v(" " + _vm._s(_vm.place))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.characteristic
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("characteristic")))]),
                    _vm._v(" " + _vm._s(_vm.characteristic))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.thicknessMm && !_vm.isDefaultThickness
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("thickness")))]),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("numberWithUnit")(
                            _vm.thicknessMm,
                            "mm",
                            _vm.userLocale
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fillLastRow ? _c("li") : _vm._e(),
              _vm._v(" "),
              _c("li", { staticClass: "list-break" }),
              _vm._v(" "),
              _vm.internalQualityName && _vm.user && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("internalQuality")))]),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.internalQualityName) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.logInfo && _vm.user && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("logInfo")))]),
                    _vm._v(" " + _vm._s(_vm.logInfo))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.palletInfo && _vm.user && !_vm.simplified
                ? _c("li", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("palletInfo")))]),
                    _vm._v(" " + _vm._s(_vm.palletInfo))
                  ])
                : _vm._e()
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }